module.exports = __webpack_public_path__ + "static/media/wolfmedical.f99f2426.png";